import CallsToAciton from '@components/calls-to-action';
import ComponentRenderer from '@components/cms-components/component-renderer';
import TwoColumn from '@components/two-column';
import { Yeseva } from 'app/fonts';
import type { ReactElement } from 'react';
import React from 'react';
import type { TwoColumnData } from 'types/components/two-column';
import type { DataProps } from 'types/props/data-props';

export default function TwoColumnComponent({
  context,
  description,
  eyebrow,
  heading,
  layout = 'left',
  subHeading,
  media,
  primaryCta,
  secondaryCta,
  theme,
}: DataProps<TwoColumnData>): ReactElement {
  return (
    <TwoColumn
      callsToAction={
        <CallsToAciton
          primaryCta={primaryCta}
          secondaryCta={secondaryCta}
          theme={theme}
        />
      }
      description={
        <ComponentRenderer context={context}>{description}</ComponentRenderer>
      }
      eyebrow={<span>{eyebrow}</span>}
      heading={<h2 className={Yeseva.className}>{heading}</h2>}
      layout={layout}
      media={
        <ComponentRenderer context={context}>
          {typeof media !== 'undefined'
            ? media.map(image => ({
                ...image,
                sizes: '(max-width: 768px) 100vw, 50vw',
              }))
            : undefined}
        </ComponentRenderer>
      }
      size="small"
      subHeading={<span>{subHeading}</span>}
      theme={theme}
    />
  );
}
